export const UPDATE_TEAM_REQUEST = "team/UPDATE_TEAM_REQUEST";
export const UPDATE_TEAM_SUCCESS = "team/UPDATE_TEAM_SUCCESS";
export const CHANGE_TEAM_NAME = "team/CHANGE_TEAM_NAME";
export const CHANGE_TEAM_PICTURE = "team/CHANGE_TEAM_PICTURE";
export const UPDATE_TEAM_ERROR = "team/UPDATE_TEAM_ERROR";
export const CREATE_TEAM_CONVERSATION_REQUEST =
  "team/CREATE_TEAM_CONVERSATION_REQUEST";
export const CREATE_TEAM_CONVERSATION_SUCCESS =
  "team/CREATE_TEAM_CONVERSATION_SUCCESS";
export const CREATE_TEAM_CONVERSATION_ERROR =
  "team/CREATE_TEAM_CONVERSATION_ERROR";
